import { Instance } from 'mobx-state-tree';
import { LanguageStore } from '../../../store/LanguageStore';
import { inject, observer } from 'mobx-react';
import React from 'react';
import SelectInputFormField from './SelectInputFormField';
import { Language } from '../../../store/models/Language';
import { IItemRendererProps } from '@blueprintjs/select';
import { MenuItem } from '@blueprintjs/core';
import { TLCode } from '../../../common/enums';
import { toJS } from 'mobx';
import withTranslate, { WithTranslateProps } from '../WithTranslate';

interface LanguageFormFieldProps extends WithTranslateProps {
  LanguageStore?: Instance<typeof LanguageStore>;
}

const LanguageSelectInputFormField = SelectInputFormField.ofType<any, string>();

@inject('LanguageStore')
@observer
class LanguageFormField extends React.Component<LanguageFormFieldProps> {
  renderLanguageMenuItem(item: typeof Language.Type, { handleClick, index, modifiers }: IItemRendererProps) {
    if (modifiers.matchesPredicate) {
      return (
        <MenuItem key={`language-${index}`} active={modifiers.active} onClick={handleClick} text={item.englishName!} />
      );
    } else {
      return null;
    }
  }

  filterlanguage = (query, language) => {
    return language.englishName!.toLowerCase().indexOf(query.toLowerCase()) >= 0;
  };

  render() {
    const { LanguageStore, ...otherProps } = this.props;
    return (
      <LanguageSelectInputFormField
        label={TLCode.PHARMACY_Language}
        name="languageCode"
        inline={true}
        items={toJS(LanguageStore!.getLanguageList())}
        itemValueGetter={(item) => item.alpha2}
        valueItemGetter={(value) => LanguageStore!.getByAlpha2(value)!}
        inputValueRenderer={(item) => (item != null ? item.englishName! : '')}
        itemRenderer={this.renderLanguageMenuItem}
        itemPredicate={this.filterlanguage}
        allowEmpty={true}
        identifier={'alpha2'}
        elementLabel={'englishName'}
        labelSelectAnElement={this.props.translate(TLCode.NONE)}
        helperText={this.props.translate(TLCode.CHOOSE_A_LANGUAGE)}
        {...otherProps}
      />
    );
  }
}

export default withTranslate(LanguageFormField);
